import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 1024) {
        var swiper = new Swiper(".mySwiper-1", {
            slidesPerView: 3,
            spaceBetween: 0,
            loop:true,
            initialSlide: 1,
            centeredSlides:false
        });
    }
});
